import React, { useEffect, useState } from "react";
import { EditableInputDisplay, useEditMode } from "../../EditableComponents";
import { useAuthUser } from "react-auth-kit";
import {
  Button,
  Container,
  DialogActions,
  Paper,
  TextField,
} from "@mui/material";
import {
  useGetCurrentUser,
  useGetCurrentDoctor,
  useUpdateCurrentUser,
  userValues,
  doctorValues,
  useUpdateCurrentDoctor,
} from "..";
import { LoadingPaper } from "../../LoadingComponents";
import { useGetDoctorById } from "../../DoctorComponents";

function UpdateCurrentUser() {
  const updateUserMutation = useUpdateCurrentUser();
  const updateDoctorMutation = useUpdateCurrentDoctor();
  const userQuery = useGetCurrentUser();
  const doctorQuery = useGetCurrentDoctor();

  const authUser = useAuthUser();

  // === edit mode ===
  const {
    editMode,
    enterEditMode,
    cancelEditMode,
    confirmEditMode,
    updateEditState,
    setQueryKey,
  } = useEditMode({
    editModeEnabled: false,
    updateMutation: updateUserMutation,
    initialQueryKey: ["users", "current"],
  });
  const {
    editMode: editModeDoctor,
    enterEditMode: enterEditModeDoctor,
    cancelEditMode: cancelEditModeDoctor,
    confirmEditMode: confirmEditModeDoctor,
    updateEditState: updateEditStateDoctor,
    setQueryKey: setQueryKeyDoctor,
  } = useEditMode({
    editModeEnabled: false,
    updateMutation: updateDoctorMutation,
    initialQueryKey: ["doctors", "current"],
  });

  if (userQuery.isLoading) return <LoadingPaper />;
  if (userQuery.data !== undefined)
    return (
      <Paper
        style={{
          height: "fitContent",
          width: "60%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <h2 style={{ textAlign: "center", padding: 5 }}>
          Cambio impostazioni utente
        </h2>
        <Container>
          {userValues.map((el) => {
            return (
              <EditableInputDisplay
                key={el.id}
                id={el.id}
                label={el.label}
                initialValue={userQuery.data[el.id]}
                setEditMode={editMode}
                inputMode={el.id === "date_of_birth" ? "date" : "text"}
                setParentValue={updateEditState}
              />
            );
          })}
          <Container sx={{ padding: "1vmin" }}>
            {editMode ? (
              <DialogActions>
                <Button
                  disabled={updateUserMutation.isLoading}
                  onClick={confirmEditMode}
                >
                  Conferma
                </Button>
                <Button
                  disabled={updateUserMutation.isLoading}
                  color="error"
                  onClick={cancelEditMode}
                >
                  Annulla
                </Button>
              </DialogActions>
            ) : (
              <DialogActions>
                <Button
                  disabled={updateUserMutation.isLoading}
                  onClick={enterEditMode}
                >
                  Modifica
                </Button>
              </DialogActions>
            )}
          </Container>
        </Container>
        {authUser()?.role === 3 && doctorQuery.data !== undefined && (
          <>
            <h2 style={{ textAlign: "center", padding: 5 }}>
              Cambio impostazioni prof. sanitario
            </h2>
            <Container>
              {doctorValues.map((el) => {
                return (
                  <EditableInputDisplay
                    key={el.id}
                    id={el.id}
                    label={el.label}
                    initialValue={doctorQuery.data[el.id]}
                    setEditMode={editModeDoctor}
                    inputMode={"text"}
                    setParentValue={updateEditStateDoctor}
                  />
                );
              })}
              <Container sx={{ padding: "1vmin" }}>
                {editModeDoctor ? (
                  <DialogActions>
                    <Button
                      disabled={updateDoctorMutation.isLoading}
                      onClick={confirmEditModeDoctor}
                    >
                      Conferma
                    </Button>
                    <Button
                      disabled={updateDoctorMutation.isLoading}
                      color="error"
                      onClick={cancelEditModeDoctor}
                    >
                      Annulla
                    </Button>
                  </DialogActions>
                ) : (
                  <DialogActions>
                    <Button
                      disabled={updateDoctorMutation.isLoading}
                      onClick={enterEditModeDoctor}
                    >
                      Modifica
                    </Button>
                  </DialogActions>
                )}
              </Container>
            </Container>
          </>
        )}
      </Paper>
    );
}

export default UpdateCurrentUser;
